import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const renderApp = (element, config) => {
  const root = ReactDOM.createRoot(element || document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>,
  );
  return root.unmount.bind(root);
};

(window || global)["renderApp"] = renderApp;

// TODO: Change below condition with proper configurations.
if (process.env.REACT_APP_ISLOCAL === "true") {
  (window || global)["renderApp"]();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
